<template>
  <div :class="['modal', { 'is-active': show }]">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Choose a Template</p>
        <button class="delete" v-on:click="hideModal"></button>
      </header>
      <section class="modal-card-body">
        <table class="table is-striped">
          <tr v-for="template in Object.values(templates)">
            <td>{{ template.attributes.title }}</td>
            <td class="has-text-right">
              <button
                type="button"
                class="button is-primary is-small"
                @click="onSubmit(template.attributes.body)"
              >
                Select
              </button>
            </td>
          </tr>
        </table>
      </section>
      <footer class="modal-card-foot">
        <a class="button is-link" v-on:click="hideModal">Cancel</a>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: "care-templates-modal",

  props: ["show", "templates", "hide", "onSubmit"],

  data() {
    return {
      errors: {}
    };
  },

  methods: {
    hideModal() {
      this.$props.hide();
    }
  }
};
</script>

<style lang="scss" scoped></style>
